import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Styled from './NavigationStyles';
import Avatar from '../Avatar/Avatar';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import Notifications from '../Notifications/Notifications';
import { Dropdown } from 'react-bootstrap';
import burgerIcon from '../../../images/burger-icon.svg';
import {SignInButton} from '../../styled/Button';
import Box from '../../styled/Box';
import {Image} from '../../styled/Image';
import trovaPC from '../../../images/trova-PC.svg';
import {Paragraph} from '../../styled/Typography';
import PromptModal from '../PromptModal/PromptModal';
interface NavRightProps{
  isAuth: boolean
}
const hiddenLinksPaths = ['searchresults', 'searchportal'];
const CustomToggle = React.forwardRef(({ children, onClick}:any, ref) => {

  const toggle = (e:any) => {
    e.preventDefault();
    onClick(e);
  }

  return (
    <Styled.DropToggle
      onClick={toggle}
      // @ts-ignore
      ref={ref}
    >
      <img src={burgerIcon} alt="" />
    </Styled.DropToggle>
  )
})
const NavRight = ({ isAuth }: NavRightProps) => {
  const location = useLocation();
  const [showLinks, setShowLinks] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

  const goToSearch = (e:any) => {
    if (!isAuth) {
      e.preventDefault();
      setShowLoginPrompt(true);
      return false;
    }
    return true;
  }

  const closeLoginPrompt = () => {
    setShowLoginPrompt(false);
  }

  useEffect(() => {
    setShowLinks(!hiddenLinksPaths.some((l:string) => location.pathname.includes(l)));
  }, [location.pathname]);

  return (
    <Styled.Container className="RightSignedBlock">
      {showLinks && (
        <>
          <Styled.NavLink
            to="/searchportal"
            href="/searchportal"
            className='d-none d-lg-block outlined'
            onClick={goToSearch}
          >
            Go to Search
          </Styled.NavLink>
          <Styled.NavLink
            to="/how-it-works"
            href="/how-it-works"
            className='d-none d-lg-block'>
            How it works
          </Styled.NavLink>
          <Styled.NavLink
            href="/#faqs"
            to="/#faqs"
            className='d-none d-lg-block'
          >
            FAQs
          </Styled.NavLink>
          <Styled.NavLink
            to="/about-us"
            href="/about-us"
            className='d-none d-lg-block'
          >
            About
          </Styled.NavLink>
          <Styled.NavLink
            to="mailto:info@gotrova.ai"
            href="mailto:info@gotrova.ai"
            className='d-none d-lg-block'
          >
            Contact Us
          </Styled.NavLink>
        </>
      )}
      {isAuth ? (
        <>
          <Avatar hasDrop />
          <Notifications />
          <BurgerMenu />
        </>
      ) : (
        <>
          <SignInButton to="/signin-beta" href="/signin-beta">
            Sign in
          </SignInButton>
          <Dropdown alignRight className="d-lg-none ml-3">
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu align="right">
              <Dropdown.Item href="/searchportal" className="drop-item">
                Go to Search
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="/how-it-works" className="drop-item">
                How it works
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="/#faqs" className="drop-item">
                FAQs
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="/about-us" className="drop-item">
                About
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="mailto:info@gotrova.ai" className="drop-item">
                Contact Us
              </Dropdown.Item>
              <Dropdown.Divider className="d-sm-none" />
              <Dropdown.Item className="d-sm-none text-align-center">
                <SignInButton to="/signin-beta" href="/signin-beta">
                  Sign in
                </SignInButton>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
      <PromptModal
        open={showLoginPrompt}
        message={(
          <>
            <Box display={'flex'} justifyContent={'center'} mb={4}>
              <Image src={trovaPC} />
            </Box>
            <Paragraph mb={0} color={'primaryViolet'}>
              To start searching, please sign in to your Trova account. Thanks!
            </Paragraph>
          </>
        )}
        onClose={closeLoginPrompt}
        buttonTxt="Sign In"
        buttonHref="/signin-beta"
      />
    </Styled.Container>
  )
}

export default NavRight;